{
  "app": {
    "name": "ফার্মেসি ইনভেন্টরি",
    "shortName": "PIMS",
    "tagline": "একাধিক শাখার ফার্মেসি ইনভেন্টরি, বিক্রয় ও লয়্যালটি ব্যবস্থাপনা",
    "language": "ভাষা",
    "theme": "থিম",
    "light": "লাইট",
    "dark": "ডার্ক",
    "system": "সিস্টেম",
    "loading": "লোড হচ্ছে…",
    "skipToContent": "মূল অংশে যান"
  },
  "nav": {
    "dashboard": "ড্যাশবোর্ড",
    "pos": "বিক্রয় কাউন্টার",
    "inventory": "স্টক",
    "medicines": "ওষুধ",
    "purchases": "ক্রয়",
    "customers": "গ্রাহক",
    "loyalty": "লয়্যালটি কার্ড",
    "reports": "রিপোর্ট",
    "settings": "সেটিংস",
    "sections": {
      "sell": "বিক্রয়",
      "stock": "স্টক",
      "people": "মানুষ",
      "insights": "বিশ্লেষণ"
    },
    "collapse": "সাইডবার ছোট করুন",
    "expand": "সাইডবার বড় করুন",
    "openMenu": "মেনু খুলুন",
    "search": "খুঁজুন বা যান…",
    "branch": "শাখা",
    "organization": "ফার্মেসি",
    "changePassword": "পাসওয়ার্ড পরিবর্তন",
    "signOut": "সাইন আউট",
    "account": "অ্যাকাউন্ট",
    "security": "টু-ফ্যাক্টর অথেনটিকেশন"
  },
  "auth": {
    "welcome": "আবার স্বাগতম",
    "signInHint": "কর্মী: মালিকের দেওয়া ইউজারনেম ও পাসওয়ার্ড দিন। মালিক: আপনার ইমেইল দিন।",
    "email": "ইমেইল",
    "loginId": "ইউজারনেম বা ইমেইল",
    "password": "পাসওয়ার্ড",
    "signIn": "সাইন ইন",
    "invalid": "ইউজারনেম/ইমেইল বা পাসওয়ার্ড সঠিক নয়।",
    "trust": "টু-ফ্যাক্টর অথেনটিকেশন ও রো-লেভেল সিকিউরিটি দ্বারা সুরক্ষিত।",
    "heroTitle": "সব শাখা এক জায়গা থেকে চালান",
    "heroBody": "দ্রুত কাউন্টার বিলিং, মেয়াদ-ভিত্তিক স্টক, লয়্যালটি কার্ড ও লাইভ রিপোর্ট — বাংলাদেশের ফার্মেসির জন্য তৈরি।",
    "heroPoints": [
      "কাছের মেয়াদের স্টক আগে বিক্রি হয়, স্বয়ংক্রিয়ভাবে",
      "বাংলা ও ইংরেজি, লাইট ও ডার্ক",
      "মালিক সব শাখা সরাসরি দেখতে পান"
    ],
    "mfaTitle": "টু-ফ্যাক্টর অথেনটিকেশন",
    "mfaVerifyBody": "অথেনটিকেটর অ্যাপ থেকে ৬ সংখ্যার কোড দিন।",
    "mfaEnrollBody": "মালিকের অ্যাকাউন্ট অথেন্টিকেটর অ্যাপ দিয়ে সুরক্ষিত থাকে। Google Authenticator বা Microsoft Authenticator দিয়ে QR কোডটি স্ক্যান করে ৬ সংখ্যার কোড দিন।",
    "mfaSecret": "স্ক্যান করতে না পারলে এই কী লিখুন",
    "code": "৬ সংখ্যার কোড",
    "verify": "যাচাই করুন",
    "back": "ফিরে যান",
    "codeInvalid": "কোডটি কাজ করেনি। ফোনের সময় ঠিক আছে কিনা দেখে আবার চেষ্টা করুন।"
  },
  "onboarding": {
    "title": "আপনার ফার্মেসি সেট আপ করুন",
    "body": "আপনার ফার্মেসি ও প্রথম শাখা তৈরি করুন। পরে আরও শাখা ও কর্মী যোগ করতে পারবেন।",
    "pharmacyName": "ফার্মেসির নাম",
    "branchName": "প্রথম শাখার নাম",
    "branchCode": "শাখা কোড",
    "branchCodeHint": "২–৬ অক্ষর, ইনভয়েসে ছাপা হবে (যেমন MPR → MPR-2627-000001)।",
    "create": "ফার্মেসি তৈরি করুন",
    "invitations": "আপনাকে আমন্ত্রণ জানানো হয়েছে",
    "accept": "গ্রহণ করুন",
    "noAccess": "অ্যাক্সেসের অপেক্ষায়",
    "noAccessBody": "কর্মী হলে মালিককে আপনাকে যোগ করতে বলুন। মালিক হলে লগআউট করে অথেন্টিকেটর কোড দিয়ে আবার লগইন করুন।",
    "ownerMfa": "মালিকের অ্যাকাউন্ট দিয়ে কর্মী, দাম ও টাকার হিসাব নিয়ন্ত্রণ হয়, তাই এটি অথেন্টিকেটর অ্যাপ (Google Authenticator বা Microsoft Authenticator) দিয়ে সুরক্ষিত থাকে। একবার সেটআপ করুন; কর্মীদের শুধু পাসওয়ার্ড লাগবে।",
    "setupMfa": "অথেন্টিকেটর সেটআপ করে এগিয়ে যান"
  },
  "dashboard": {
    "greeting": "শুভ {{part}}, {{name}}",
    "morning": "সকাল",
    "afternoon": "দুপুর",
    "evening": "সন্ধ্যা",
    "subtitle": "আজ {{branch}} শাখার অবস্থা।",
    "todaySales": "আজকের বিক্রয়",
    "transactions": "আজকের বিল",
    "avgBasket": "গড় বিল",
    "grossProfit": "মোট লাভ",
    "vsYesterday": "গতকালের তুলনায়",
    "salesTrend": "বিক্রয়, গত ১৪ দিন",
    "salesTrendBody": "ফেরত ও বাতিলের পর নিট বিক্রয়",
    "expiring": "শীঘ্রই মেয়াদোত্তীর্ণ",
    "expiringBody": "আগামী {{days}} দিনে মেয়াদ শেষ হবে",
    "lowStock": "স্টক কম",
    "lowStockBody": "রিঅর্ডার লেভেলে বা তার নিচে",
    "daysLeft": "{{n}} দিন",
    "units": "{{n}} টি",
    "noExpiring": "শীঘ্রই কিছু মেয়াদোত্তীর্ণ হচ্ছে না",
    "noLowStock": "স্টক ঠিক আছে",
    "newSale": "নতুন বিক্রয়",
    "hidden": "শুধু মালিক"
  },
  "pos": {
    "title": "বিক্রয় কাউন্টার",
    "search": "ওষুধ, জেনেরিক খুঁজুন বা বারকোড স্ক্যান করুন",
    "searchHint": "অন্তত ২টি অক্ষর লিখুন",
    "noResults": "কোনো ওষুধ পাওয়া যায়নি",
    "inStock": "স্টকে {{n}}টি",
    "outOfStock": "স্টক নেই",
    "exp": "মেয়াদ {{date}}",
    "cart": "চলতি বিল",
    "emptyCart": "বিল খালি",
    "emptyCartBody": "ওষুধ খুঁজে Enter চাপুন।",
    "qty": "পরিমাণ",
    "discount": "ছাড় %",
    "remove": "{{name}} সরান",
    "customer": "গ্রাহক / লয়্যালটি কার্ড",
    "customerPlaceholder": "কার্ড নম্বর বা মোবাইল",
    "apply": "প্রয়োগ",
    "member": "{{plan}} · {{discount}}% ছাড় · {{points}} পয়েন্ট",
    "subtotal": "উপমোট",
    "lineDiscounts": "ছাড়",
    "estimated": "আনুমানিক মোট",
    "estimateNote": "চূড়ান্ত মূল্য, লয়্যালটি ছাড় ও ব্যাচ বণ্টন সার্ভারে নিরাপদে হিসাব হয়।",
    "payment": "পেমেন্ট",
    "tendered": "গৃহীত টাকা",
    "change": "ফেরত",
    "complete": "বিক্রয় সম্পন্ন",
    "clear": "বিল মুছুন",
    "prescription": "প্রেসক্রিপশন প্রয়োজন",
    "prescriptionBody": "এই বিলে নিয়ন্ত্রিত বা প্রেসক্রিপশন-নির্ভর ওষুধ আছে।",
    "patientName": "রোগীর নাম",
    "doctorName": "ডাক্তারের নাম",
    "doctorReg": "বিএমডিসি রেজি. নং",
    "prescriptionDate": "প্রেসক্রিপশনের তারিখ",
    "success": "বিক্রয় সম্পন্ন হয়েছে",
    "invoice": "ইনভয়েস",
    "total": "মোট",
    "paid": "পরিশোধিত",
    "due": "বাকি",
    "pointsEarned": "অর্জিত পয়েন্ট",
    "print": "রসিদ প্রিন্ট",
    "newSale": "নতুন বিক্রয়",
    "thanks": "ধন্যবাদ। দ্রুত সুস্থ হয়ে উঠুন।",
    "shortcuts": "শর্টকাট",
    "methods": {
      "cash": "নগদ",
      "bkash": "বিকাশ",
      "nagad": "নগদ (মোবাইল)",
      "rocket": "রকেট",
      "card": "কার্ড",
      "bank_transfer": "ব্যাংক",
      "loyalty_points": "পয়েন্ট"
    },
    "schedule": {
      "otc": "OTC",
      "rx": "Rx",
      "controlled": "নিয়ন্ত্রিত"
    },
    "loyaltyDiscount": "লয়্যালটি ছাড়",
    "rack": "র‍্যাক {{rack}}"
  },
  "inventory": {
    "title": "স্টক",
    "subtitle": "{{branch}} শাখার স্টক, মেয়াদ ও রিঅর্ডার সতর্কতা",
    "batch": "ব্যাচ",
    "medicine": "ওষুধ",
    "expiry": "মেয়াদ",
    "onHand": "হাতে আছে",
    "valueMrp": "মূল্য (MRP)",
    "reorderLevel": "রিঅর্ডার",
    "sellable": "বিক্রয়যোগ্য",
    "rack": "র‍্যাক",
    "stockOnHand": "বর্তমান স্টক",
    "filter": "নাম বা র‍্যাক দিয়ে খুঁজুন",
    "noStock": "এই শাখায় এখনও স্টক নেই",
    "noStockBody": "ক্রয় পাতা থেকে ওপেনিং স্টক বা ক্রয় এন্ট্রি দিন।",
    "nextExpiry": "পরবর্তী মেয়াদ",
    "price": "দাম",
    "batches_one": "{{n}}টি ব্যাচ",
    "batches_other": "{{n}}টি ব্যাচ"
  },
  "common": {
    "close": "বন্ধ করুন",
    "cancel": "বাতিল",
    "save": "সংরক্ষণ",
    "pageOf": "পৃষ্ঠা {{page}} / {{pages}}",
    "previous": "আগের",
    "next": "পরের"
  },
  "medicines": {
    "title": "ওষুধ",
    "subtitle": "ক্যাটালগে {{n}}টি ওষুধ",
    "add": "ওষুধ যোগ করুন",
    "addFirst": "প্রথম ওষুধ যোগ করুন",
    "edit": "ওষুধ সম্পাদনা",
    "editNamed": "{{name}} সম্পাদনা",
    "dialogBody": "ক্যাটালগ সব শাখায় একই। র‍্যাক ও রিঅর্ডার লেভেল {{branch}} শাখার জন্য সংরক্ষিত হবে।",
    "brandName": "ব্র্যান্ড নাম",
    "strength": "শক্তি (মাত্রা)",
    "generic": "জেনেরিক নাম",
    "manufacturer": "কোম্পানি",
    "form": "ধরন",
    "unit": "বিক্রয় একক",
    "unitHint": "স্টক ও দাম এই এককে গণনা হয়।",
    "rack": "র‍্যাক / তাক",
    "rackHint": "এই শাখার তাক, যেমন A-3",
    "schedule": "শ্রেণি",
    "schedules": {
      "otc": "OTC",
      "rx": "প্রেসক্রিপশন (Rx)",
      "controlled": "নিয়ন্ত্রিত"
    },
    "scheduleHint": {
      "otc": "প্রেসক্রিপশন ছাড়া বিক্রি করা যায়।",
      "rx": "শুধু প্রেসক্রিপশনে বিক্রয়যোগ্য।",
      "controlled": "নারকোটিক/সাইকোট্রপিক: বিক্রয়ের সময় প্রেসক্রিপশনের তথ্য লাগবে।"
    },
    "reorderLevel": "রিঅর্ডার লেভেল",
    "reorderHint": "স্টক এতে নামলে সতর্ক করবে",
    "wholeNumber": "পূর্ণসংখ্যা দিন",
    "barcodes": "বারকোড",
    "barcodesHint": "স্ক্যান বা টাইপ করুন; একাধিক হলে কমা দিন।",
    "sku": "SKU / কোড",
    "notes": "নোট",
    "loyaltyEligible": "লয়্যালটি ছাড় প্রযোজ্য",
    "active": "সক্রিয় (বিক্রয়যোগ্য)",
    "inactive": "নিষ্ক্রিয়",
    "required": "আবশ্যক",
    "created": "{{name}} যোগ হয়েছে",
    "updated": "{{name}} হালনাগাদ হয়েছে",
    "search": "ব্র্যান্ড, জেনেরিক বা SKU খুঁজুন",
    "showInactive": "নিষ্ক্রিয়গুলোও দেখান",
    "noMatch": "কোনো ওষুধ মেলেনি",
    "empty": "এখনও কোনো ওষুধ নেই",
    "emptyBody": "যে ওষুধ বিক্রি করেন সেগুলো যোগ করুন। তারপর ক্রয় পাতায় ওপেনিং স্টক বা ক্রয় এন্ট্রি দিন।",
    "medicine": "ওষুধ",
    "perUnit": "প্রতি {{unit}}",
    "forms": {
      "tablet": "ট্যাবলেট",
      "capsule": "ক্যাপসুল",
      "syrup": "সিরাপ",
      "suspension": "সাসপেনশন",
      "solution": "সলিউশন",
      "injection": "ইনজেকশন",
      "infusion": "স্যালাইন (IV)",
      "drops": "ড্রপ",
      "cream": "ক্রিম",
      "ointment": "মলম",
      "gel": "জেল",
      "lotion": "লোশন",
      "inhaler": "ইনহেলার",
      "nebuliser_solution": "নেবুলাইজার সলিউশন",
      "powder": "পাউডার",
      "sachet": "স্যাশে",
      "suppository": "সাপোজিটরি",
      "spray": "স্প্রে",
      "patch": "প্যাচ",
      "device": "ডিভাইস",
      "other": "অন্যান্য"
    }
  },
  "purchases": {
    "subtitle": "সাপ্লায়ারের ইনভয়েস গ্রহণ ও {{branch}} শাখায় স্টক তোলা",
    "tabs": {
      "receive": "মাল গ্রহণ",
      "opening": "ওপেনিং স্টক",
      "history": "ইতিহাস"
    },
    "noAccess": "ক্রয় সীমিত",
    "noAccessBody": "ক্রয়মূল্য শুধু মালিক, ম্যানেজার ও হিসাবরক্ষক দেখতে পারেন।",
    "supplier": "সাপ্লায়ার",
    "chooseSupplier": "সাপ্লায়ার বাছুন…",
    "newSupplier": "নতুন সাপ্লায়ার",
    "supplierName": "সাপ্লায়ারের নাম",
    "contactPerson": "যোগাযোগের ব্যক্তি",
    "phone": "মোবাইল",
    "address": "ঠিকানা",
    "supplierCreated": "সাপ্লায়ার {{name}} যোগ হয়েছে",
    "invoiceNo": "সাপ্লায়ার ইনভয়েস নং",
    "invoiceDate": "ইনভয়েসের তারিখ",
    "items": "গৃহীত পণ্য",
    "openingItems": "এখন তাকে যা আছে",
    "addMedicine": "ওষুধ যোগ করুন: নাম লিখুন বা বারকোড স্ক্যান করুন",
    "noItems": "এখনও কোনো পণ্য নেই",
    "noItemsBody": "সাপ্লায়ারের ইনভয়েসের প্রতিটি ওষুধ ওপরে খুঁজে যোগ করুন।",
    "openingBody": "আজ তাকে যা আছে গুনে ব্যাচ অনুযায়ী এন্ট্রি দিন। শাখা চালুর সময় একবারই করতে হয়।",
    "batchNo": "ব্যাচ",
    "expiry": "মেয়াদ",
    "qty": "পরিমাণ",
    "bonus": "বোনাস",
    "extra": "অতিরিক্ত",
    "unitCost": "ক্রয়মূল্য",
    "mrp": "MRP",
    "salePrice": "বিক্রয়মূল্য",
    "lineTotal": "মোট",
    "perUnit": "পরিমাণ ও দাম প্রতি {{unit}}",
    "discount": "ইনভয়েস ছাড়",
    "paidNow": "এখন পরিশোধ",
    "paidHint": "বাকিতে কিনলে ০ রাখুন।",
    "openingNote": "ক্রয়মূল্য হলো প্রতি এককের কেনা দাম; লাভের রিপোর্টে ব্যবহৃত হয়, বিক্রয়কর্মীরা দেখতে পান না।",
    "lines": "লাইন",
    "dueToSupplier": "সাপ্লায়ারের পাওনা",
    "saveReceipt": "মাল গ্রহণ সংরক্ষণ",
    "saveOpening": "ওপেনিং স্টক সংরক্ষণ",
    "discard": "খসড়া বাদ দিন",
    "openingSaved": "ওপেনিং স্টক সংরক্ষিত ({{n}}টি ব্যাচ)",
    "received": "মাল গ্রহণ {{no}} সংরক্ষিত · {{total}}",
    "noReceipts": "এখনও কোনো মাল গ্রহণ নেই",
    "receiptNo": "রসিদ",
    "date": "তারিখ",
    "paidInFull": "পরিশোধিত",
    "err": {
      "batch": "আবশ্যক",
      "expiry": "মাস বাছুন",
      "expired": "মেয়াদ শেষ",
      "quantity": "০-এর বেশি পূর্ণসংখ্যা",
      "bonus": "পূর্ণসংখ্যা",
      "money": "যেমন 12.50",
      "aboveMrp": "MRP-এর বেশি",
      "supplier": "সাপ্লায়ার বাছুন",
      "futureDate": "ভবিষ্যতের তারিখ নয়",
      "duplicate": "একই ব্যাচ দুবার",
      "discount": "০ থেকে সাবটোটালের মধ্যে",
      "paid": "০ থেকে মোটের মধ্যে"
    }
  },
  "customers": {
    "subtitle": "{{n}} জন গ্রাহক",
    "add": "গ্রাহক যোগ করুন",
    "edit": "গ্রাহক সম্পাদনা",
    "editNamed": "{{name}} সম্পাদনা",
    "dialogBody": "গ্রাহক তালিকা সব শাখায় একই। লয়্যালটি কার্ডের জন্য মোবাইল নম্বর লাগবে।",
    "name": "গ্রাহকের নাম",
    "phoneHint": "গ্রাহক খুঁজতে ও লয়্যালটি কার্ডে ব্যবহৃত হয়।",
    "creditLimit": "বাকির সীমা",
    "creditHint": "০ = বাকিতে বিক্রি নয়।",
    "active": "সক্রিয়",
    "created": "{{name}} যোগ হয়েছে",
    "updated": "{{name}} হালনাগাদ হয়েছে",
    "search": "নাম বা মোবাইল খুঁজুন",
    "noMatch": "কোনো গ্রাহক মেলেনি",
    "empty": "এখনও কোনো গ্রাহক নেই",
    "emptyBody": "নিয়মিত গ্রাহক যোগ করুন — বাকিতে বিক্রি ও লয়্যালটি কার্ড দিতে।",
    "due": "বাকি",
    "noCard": "কার্ড নেই"
  },
  "loyalty": {
    "subtitle": "ছাড় ও পয়েন্টসহ সদস্য কার্ড, সব শাখায় চলবে",
    "tabs": {
      "members": "সদস্য",
      "plans": "প্ল্যান"
    },
    "filter": "সদস্য ফিল্টার",
    "filters": {
      "active": "সক্রিয়",
      "expiring": "শীঘ্রই শেষ",
      "expired": "মেয়াদোত্তীর্ণ",
      "all": "সব"
    },
    "states": {
      "active": "সক্রিয়",
      "expiring": "শীঘ্রই শেষ",
      "upcoming": "পরে শুরু",
      "expired": "মেয়াদোত্তীর্ণ",
      "cancelled": "বাতিল"
    },
    "searchMembers": "নাম, মোবাইল বা কার্ড নং খুঁজুন",
    "enroll": "সদস্য করুন",
    "enrollBody": "লয়্যালটি কার্ড দিন বা নবায়ন করুন। নবায়ন বর্তমান মেয়াদ শেষের পরদিন থেকে শুরু হয়।",
    "enrollPay": "সদস্য করুন · {{fee}} নিন",
    "enrollNamed": "{{name}}-কে লয়্যালটি কার্ড দিন",
    "renewNamed": "{{name}}-এর কার্ড নবায়ন",
    "replaceNamed": "{{name}}-এর কার্ড বদলান",
    "cancelNamed": "{{name}}-এর সদস্যপদ বাতিল",
    "customer": "গ্রাহক",
    "findCustomer": "নাম বা মোবাইলে গ্রাহক খুঁজুন",
    "noPhone": "মোবাইল নম্বর নেই",
    "change": "বদলান",
    "plan": "প্ল্যান",
    "planSummary": "{{fee}} · {{discount}}% ছাড় · {{months}} মাস",
    "cardNo": "কার্ড নম্বর",
    "cardNoHint": "খালি রাখলে নম্বর তৈরি হবে, অথবা ছাপানো কার্ডের নম্বর দিন।",
    "autoNumber": "স্বয়ংক্রিয়",
    "newCardNo": "নতুন কার্ড নম্বর",
    "noActivePlan": "এখনও কোনো প্ল্যান চালু নেই। মালিক লয়্যালটি → প্ল্যান থেকে ফি ও সুবিধা ঠিক করবেন।",
    "enrolled": "কার্ড প্রস্তুত",
    "validTill": "মেয়াদ {{date}} পর্যন্ত",
    "feeCollected": "গ্রাহকের কাছ থেকে {{fee}} নিন।",
    "done": "সম্পন্ন",
    "validity": "মেয়াদ",
    "noMembers": "এখানে কোনো সদস্য নেই",
    "noMembersBody": "প্রথম লয়্যালটি কার্ড দিতে একজন গ্রাহককে সদস্য করুন।",
    "cardReplaced": "বদলানো",
    "reason": "কারণ",
    "cancelTitle": "সদস্যপদ বাতিল",
    "cancelBody": "{{name}} এখনই ছাড় হারাবেন। ফি স্বয়ংক্রিয়ভাবে ফেরত হবে না।",
    "cancelConfirm": "সদস্যপদ বাতিল করুন",
    "cancelled": "সদস্যপদ বাতিল হয়েছে",
    "replaceTitle": "হারানো বা নষ্ট কার্ড বদলান",
    "replaceBody": "{{name}}-এর পুরোনো কার্ড আর চলবে না; সদস্যপদ ও পয়েন্ট নতুন কার্ডে যাবে।",
    "replaceConfirm": "নতুন কার্ড দিন",
    "replacedToast": "নতুন কার্ড {{no}} দেওয়া হয়েছে",
    "programme": "লয়্যালটি প্রোগ্রাম",
    "programmeBody": "বন্ধ থাকলে কোনো কার্ডে ছাড় বা পয়েন্ট মিলবে না এবং কেউ সদস্য হতে পারবে না।",
    "programmeOn": "প্রোগ্রাম চালু",
    "planOn": "চালু",
    "planOff": "বন্ধ",
    "planName": "প্ল্যানের নাম",
    "months": "মাস",
    "fee": "কার্ড ফি",
    "discount": "ছাড়",
    "discountHint": "লয়্যালটি-যোগ্য ওষুধে, সর্বোচ্চ ৫০%।",
    "maxDiscount": "প্রতি বিলে সর্বোচ্চ ছাড়",
    "optional": "ঐচ্ছিক",
    "pointsPer100": "প্রতি ৳১০০-তে পয়েন্ট",
    "pointsHint": "০ = পয়েন্ট নেই।",
    "pointValue": "১ পয়েন্টের মূল্য",
    "minRedeem": "ভাঙাতে ন্যূনতম পয়েন্ট",
    "offerPlan": "এই প্ল্যান গ্রাহকদের দিন",
    "planSaved": "{{name}} সংরক্ষিত",
    "addPlan": "প্ল্যান যোগ করুন",
    "newPlanName": "প্ল্যান {{n}}",
    "ownerOnly": "শুধু মালিক প্ল্যান বদলাতে পারেন।",
    "err": {
      "name": "২–৬০ অক্ষর",
      "months": "১ থেকে ৩৬",
      "discount": "০ থেকে ৫০",
      "points": "০ থেকে ১০০০",
      "fix": "চিহ্নিত ঘরগুলো ঠিক করুন।"
    }
  },
  "settings": {
    "subtitle": "স্টাফ, অ্যাক্সেস, শাখা ও ফার্মেসির নিয়ম",
    "tabs": {
      "staff": "স্টাফ ও অ্যাক্সেস",
      "branches": "শাখা",
      "pharmacy": "ফার্মেসি"
    },
    "noAccess": "শুধু মালিক সেটিংস বদলাতে পারেন।",
    "staff": "স্টাফ",
    "addStaff": "স্টাফ যোগ করুন",
    "addStaffBody": "এই ব্যক্তির জন্য ইউজারনেম ও পাসওয়ার্ড তৈরি করে। ইমেইল লাগবে না: ইউজারনেম ও পাসওয়ার্ড সরাসরি তাকে দিন।",
    "username": "ইউজারনেম",
    "usernameHint": "৩–৩০টি ছোট হাতের অক্ষর বা সংখ্যা, যেমন rafiq বা rafiq.mpr। অন্য কারও সাথে মিলবে না।",
    "usernameInvalid": "৩–৩০টি ছোট হাতের অক্ষর, সংখ্যা, ডট, ড্যাশ বা আন্ডারস্কোর দিন।",
    "fullName": "পূর্ণ নাম",
    "email": "ইমেইল",
    "role": "ভূমিকা",
    "tempPassword": "অস্থায়ী পাসওয়ার্ড",
    "passwordHint": "১০+ অক্ষর, বড় ও ছোট হাতের অক্ষর এবং সংখ্যা।",
    "passwordWeak": "১০+ অক্ষর, বড় ও ছোট হাতের অক্ষর এবং সংখ্যা দিন।",
    "generate": "নতুন পাসওয়ার্ড তৈরি",
    "branches": "শাখা",
    "pickBranch": "অন্তত একটি শাখা বাছুন।",
    "allBranches": "এই ভূমিকা সব শাখায় কাজ করে।",
    "fineTuneLater": "প্রথম লগইনের পর ঠিক কী কী করতে পারবে তা নির্ধারণ করতে পারবেন (ম্যানেজ)।",
    "staffAdded": "স্টাফ যোগ হয়েছে",
    "loginCreated": "লগইন তৈরি হয়েছে। ইউজারনেম: {{username}}।",
    "loginExists": "{{username}} ইউজারনেমটি আগেই ব্যবহৃত। অন্যটি দিন, যেমন {{username}}.{{branch}}।",
    "loginUnavailable": "{{username}}-এর জন্য আমন্ত্রণ তৈরি হয়েছে, কিন্তু লগইন স্বয়ংক্রিয়ভাবে তৈরি করা যায়নি (admin-users ফাংশন চালু নেই)। Supabase → Authentication → Add user থেকে {{email}} ইমেইল ও Auto Confirm দিয়ে ইউজার তৈরি করুন, তারপর ইউজারনেম দিয়ে লগইন করবেন।",
    "copy": "ইউজারনেম ও পাসওয়ার্ড কপি",
    "handOver": "এগুলো গোপনে তাকে দিন। লগইনের পর অ্যাকাউন্ট মেনু থেকে পাসওয়ার্ড বদলানো যাবে।",
    "next1": "অ্যাপ খুলে এই ইউজারনেম ও পাসওয়ার্ডে লগইন করবেন।",
    "next2": "প্রথম লগইনেই স্বয়ংক্রিয়ভাবে আপনার ফার্মেসিতে যুক্ত হবেন (৩ দিনের মধ্যে)।",
    "next3": "পাসওয়ার্ড ভুলে গেলে Manage → পাসওয়ার্ড রিসেট।",
    "person": "ব্যক্তি",
    "lastSignIn": "শেষ লগইন",
    "never": "কখনও না",
    "all": "সব শাখা",
    "custom": "কাস্টম",
    "manage": "ম্যানেজ",
    "manageNamed": "{{name}} ম্যানেজ",
    "notSelf": "এখান থেকে নিজের অ্যাক্সেস বদলানো যায় না।",
    "pending": "অপেক্ষমাণ আমন্ত্রণ",
    "noPending": "কোনো অপেক্ষমাণ আমন্ত্রণ নেই",
    "expires": "মেয়াদ {{date}}",
    "revoke": "প্রত্যাহার",
    "resetPassword": "পাসওয়ার্ড রিসেট",
    "resetPasswordBody": "নতুন অস্থায়ী পাসওয়ার্ড তৈরি হবে। পুরোনো পাসওয়ার্ড সাথে সাথে বাতিল হবে।",
    "newPasswordFor": "{{name}}-এর নতুন পাসওয়ার্ড",
    "resetOnlyStaff": "শুধু ইউজারনেমওয়ালা কর্মীর পাসওয়ার্ড এখানে রিসেট করা যায়।",
    "accessHint": "ভূমিকা থেকে শুরু। টিক দিয়ে বা তুলে আলাদা অনুমতি দিন বা সরান।",
    "resetToRole": "ভূমিকার ডিফল্টে ফেরান",
    "ownerAll": "মালিকের সবসময় পূর্ণ অ্যাক্সেস থাকে।",
    "saveAccess": "অ্যাক্সেস সংরক্ষণ",
    "accessSaved": "{{name}}-এর অ্যাক্সেস সংরক্ষিত",
    "groups": {
      "sales": "বিক্রি",
      "stock": "ওষুধ ও স্টক",
      "purchases": "ক্রয়",
      "customers": "গ্রাহক",
      "loyalty": "লয়্যালটি কার্ড",
      "reports": "রিপোর্ট"
    },
    "perms": {
      "sales.create": "কাউন্টারে বিক্রি (POS)",
      "sales.credit": "বাকিতে বিক্রি",
      "sales.void": "বিক্রি বাতিল",
      "sales.return": "গ্রাহকের ফেরত নেওয়া",
      "catalog.manage": "ওষুধ যোগ ও সম্পাদনা",
      "pricing.manage": "বিক্রয়মূল্য পরিবর্তন",
      "stock.adjust": "স্টক সমন্বয় / ওপেনিং স্টক",
      "purchases.view": "ক্রয় ও সাপ্লায়ারের দাম দেখা",
      "purchases.receive": "সাপ্লায়ার থেকে মাল গ্রহণ",
      "purchases.return": "সাপ্লায়ারকে মাল ফেরত",
      "suppliers.manage": "সাপ্লায়ার যোগ ও সম্পাদনা",
      "suppliers.pay": "সাপ্লায়ারকে পরিশোধ",
      "customers.manage": "গ্রাহক যোগ ও সম্পাদনা",
      "customers.collect": "গ্রাহকের বাকি আদায়",
      "loyalty.enroll": "লয়্যালটি কার্ড দেওয়া ও নবায়ন",
      "loyalty.cancel": "লয়্যালটি কার্ড বাতিল বা বদল",
      "loyalty.manage_plans": "লয়্যালটি প্ল্যান সম্পাদনা",
      "reports.view": "রিপোর্ট ও ড্যাশবোর্ডের হিসাব দেখা",
      "reports.view_cost": "ক্রয়মূল্য ও লাভ দেখা",
      "data.export": "ডেটা এক্সপোর্ট (CSV)",
      "controlled.register.view": "নিয়ন্ত্রিত ওষুধের রেজিস্টার",
      "audit.view": "অডিট লগ"
    },
    "roles": {
      "owner": "মালিক",
      "manager": "শাখা ম্যানেজার",
      "salesman": "বিক্রয়কর্মী",
      "accountant": "হিসাবরক্ষক",
      "auditor": "অডিটর"
    },
    "roleHints": {
      "owner": "স্টাফ ও সেটিংসসহ সবকিছুতে পূর্ণ অ্যাক্সেস।",
      "manager": "নির্ধারিত শাখা চালান: বিক্রি, স্টক, ক্রয়, রিপোর্ট।",
      "salesman": "কাউন্টারে বিক্রি, গ্রাহক ও লয়্যালটি কার্ড।",
      "accountant": "সব শাখা: রিপোর্ট, ক্রয়, পরিশোধ। বিক্রি নয়।",
      "auditor": "সব শাখা, শুধু দেখা: রিপোর্ট ও অডিট।"
    },
    "addBranch": "শাখা যোগ করুন",
    "editBranch": "শাখা সম্পাদনা",
    "editNamed": "{{name}} সম্পাদনা",
    "branchBody": "প্রতিটি শাখার নিজস্ব স্টক, ইনভয়েস ও স্টাফ থাকে।",
    "branchName": "শাখার নাম",
    "codeFixed": "কোডটি ইনভয়েসে ছাপা হয়, বদলানো যায় না।",
    "codeInvalid": "২–৬টি অক্ষর বা সংখ্যা",
    "branchOpen": "শাখা খোলা",
    "branchSaved": "{{name}} সংরক্ষিত",
    "closed": "বন্ধ",
    "general": "সাধারণ",
    "vat": "ভ্যাট",
    "vatHint": "দামের মধ্যে অন্তর্ভুক্ত; ভ্যাট-নিবন্ধিত না হলে ০।",
    "selling": "বিক্রির নিয়ম",
    "salesmanDiscount": "সর্বোচ্চ ছাড়: বিক্রয়কর্মী",
    "managerDiscount": "সর্বোচ্চ ছাড়: ম্যানেজার",
    "discountHint": "প্রতি লাইনে; এর বেশি হলে উচ্চতর ভূমিকা লাগবে।",
    "rounding": "নগদ রাউন্ডিং",
    "roundingNone": "রাউন্ডিং নয়",
    "roundingTaka": "নিকটতম টাকায়",
    "returnDays": "ফেরতের সময়",
    "returnHint": "কত দিনের মধ্যে ফেরত নেওয়া যাবে।",
    "voidHours": "বাতিলের সময়",
    "voidHint": "কত ঘণ্টার মধ্যে বিক্রি বাতিল করা যাবে।",
    "rxNeeded": "Rx ওষুধে প্রেসক্রিপশনের তথ্য বাধ্যতামূলক",
    "expiry": "মেয়াদ",
    "blockDays": "মেয়াদের আগে বিক্রি বন্ধ",
    "blockHint": "০ = শুধু মেয়াদোত্তীর্ণ ব্যাচ বন্ধ।",
    "alertDays": "মেয়াদ সতর্কতা",
    "alertHint": "এত দিনের মধ্যে মেয়াদ শেষ হলে দেখাবে।",
    "days": "দিন",
    "hours": "ঘণ্টা",
    "saveSettings": "সেটিংস সংরক্ষণ",
    "saved": "সেটিংস সংরক্ষিত",
    "outOfRange": "সীমার বাইরে",
    "loginUnavailableShort": "admin-users ফাংশন চালু নেই।",
    "remove": "ফার্মেসি থেকে সরান",
    "removeBody": "এই ব্যক্তির প্রবেশাধিকার বন্ধ হবে। আগের বিক্রি ও রেকর্ড থেকে যাবে। পরে আবার ফিরিয়ে আনা যাবে।",
    "removeConfirm": "{{name}}-কে সরাবেন? তিনি আর এই ফার্মেসিতে লগইন করতে পারবেন না।",
    "removeYes": "হ্যাঁ, সরান",
    "removed": "{{name}}-কে সরানো হয়েছে",
    "restored": "{{name}}-কে ফিরিয়ে আনা হয়েছে",
    "removedStaff": "সরানো কর্মী",
    "restore": "ফিরিয়ে আনুন",
    "restoreNamed": "{{name}}-কে ফিরিয়ে আনুন"
  },
  "reports": {
    "subtitle": "বিক্রি, লাভ, স্টকের মূল্য ও মেয়াদ",
    "noAccess": "রিপোর্ট দেখার অনুমতি নেই।",
    "tabs": {
      "sales": "বিক্রি",
      "stock": "স্টকের মূল্য",
      "expiry": "মেয়াদ",
      "low": "কম স্টক"
    },
    "period": "সময়কাল",
    "presets": {
      "today": "আজ",
      "yesterday": "গতকাল",
      "last7": "গত ৭ দিন",
      "thisMonth": "এই মাস",
      "lastMonth": "গত মাস",
      "custom": "কাস্টম"
    },
    "from": "থেকে",
    "to": "পর্যন্ত",
    "badRange": "শেষ তারিখ শুরুর পরে হতে হবে",
    "allBranches": "সব শাখা",
    "exportCsv": "CSV এক্সপোর্ট",
    "totals": "মোট",
    "netSales": "নিট বিক্রি",
    "bills": "বিল",
    "discounts": "ছাড়",
    "returns": "ফেরত",
    "grossProfit": "মোট লাভ",
    "byDay": "দিনভিত্তিক",
    "byBranch": "শাখাভিত্তিক",
    "noSales": "এই সময়ে কোনো বিক্রি নেই",
    "skus": "ওষুধ",
    "units": "একক",
    "valueCost": "মূল্য (ক্রয়)",
    "expiredUnits": "মেয়াদোত্তীর্ণ একক",
    "total": "মোট",
    "within": "যত দিনের মধ্যে মেয়াদ শেষ",
    "daysN": "{{n}} দিন"
  },
  "comingSoon": {
    "title": "পরবর্তী ধাপে আসছে",
    "body": "এই মডিউলের ডাটাবেস প্রস্তুত ও পরীক্ষিত। স্ক্রিন তৈরির কাজ চলছে।"
  },
  "errors": {
    "unknown": "কিছু একটা সমস্যা হয়েছে। আবার চেষ্টা করুন।",
    "network": "ইন্টারনেট সংযোগ নেই মনে হচ্ছে।",
    "forbidden": "এই কাজের অনুমতি আপনার নেই।",
    "mfa_required": "চালিয়ে যেতে টু-ফ্যাক্টর যাচাই করুন।",
    "not_authenticated": "আবার সাইন ইন করুন।",
    "insufficient_stock": "বিক্রয়যোগ্য স্টক যথেষ্ট নেই।",
    "discount_limit": "এই ছাড় আপনার সীমার বেশি। ম্যানেজারকে বলুন।",
    "credit_limit": "এতে গ্রাহকের বাকির সীমা ছাড়িয়ে যাবে।",
    "customer_required": "বাকিতে বিক্রয়ের জন্য গ্রাহক নির্বাচন করুন।",
    "prescription_required": "এই বিলের জন্য প্রেসক্রিপশনের তথ্য প্রয়োজন।",
    "loyalty_inactive": "এই কার্ডের আজ কোনো সক্রিয় সদস্যপদ নেই।",
    "overpayment": "কার্ড ও মোবাইল পেমেন্ট মোট টাকার বেশি হতে পারে না।",
    "invalid_phone": "সঠিক মোবাইল নম্বর দিন (01XXXXXXXXX)।",
    "duplicate_medicine": "এই ওষুধটি (একই ব্র্যান্ড, ধরন, শক্তি ও কোম্পানি) আগেই আছে।",
    "duplicate_sku": "এই SKU অন্য ওষুধে ব্যবহৃত।",
    "duplicate_barcode": "এই বারকোড অন্য ওষুধের।",
    "invalid_barcode": "বারকোড ৪–৬৪টি অক্ষর, সংখ্যা বা ড্যাশ হতে হবে।",
    "invalid_medicine_field": "কোনো একটি ঘর অনেক লম্বা বা ভুল।",
    "duplicate_supplier": "এই নামে সাপ্লায়ার আগেই আছে।",
    "invalid_name": "নাম আবশ্যক।",
    "not_found": "পাওয়া যায়নি। হয়তো মুছে ফেলা হয়েছে।",
    "expired_batch": "মেয়াদ ভবিষ্যতের হতে হবে।",
    "price_above_mrp": "বিক্রয়মূল্য MRP-এর বেশি হতে পারে না।",
    "invalid_price": "MRP শূন্যের বেশি হতে হবে।",
    "invalid_cost": "ক্রয়মূল্য ঋণাত্মক হতে পারে না।",
    "invalid_quantity": "পরিমাণ ০-এর বেশি পূর্ণসংখ্যা হতে হবে।",
    "invalid_batch": "ব্যাচ নম্বর আবশ্যক।",
    "duplicate_items": "একই ওষুধের একই ব্যাচ দুবার আছে।",
    "invalid_discount": "ছাড় ০ থেকে সাবটোটালের মধ্যে হতে হবে।",
    "invalid_payment": "পরিশোধ ০ থেকে মোটের মধ্যে হতে হবে।",
    "invalid_date": "ইনভয়েসের তারিখ ভবিষ্যতের হতে পারে না।",
    "invalid_supplier": "সাপ্লায়ার পাওয়া যায়নি বা নিষ্ক্রিয়।",
    "invalid_medicine": "ওষুধ পাওয়া যায়নি বা নিষ্ক্রিয়।",
    "23505": "এটি আগেই আছে (যেমন একই সাপ্লায়ার ইনভয়েস নম্বর আগে এন্ট্রি হয়েছে)।",
    "duplicate_phone": "এই মোবাইল নম্বর অন্য গ্রাহকের।",
    "phone_required": "লয়্যালটি কার্ডে মোবাইল নম্বর লাগবে। আগে গ্রাহক সম্পাদনা করুন।",
    "loyalty_disabled": "লয়্যালটি প্রোগ্রাম বন্ধ (লয়্যালটি → প্ল্যান)।",
    "invalid_plan": "এই প্ল্যান চালু নেই।",
    "invalid_customer": "গ্রাহক পাওয়া যায়নি বা নিষ্ক্রিয়।",
    "invalid_card_no": "কার্ড নম্বর সঠিক নয় (চেক ডিজিট)।",
    "card_mismatch": "এই গ্রাহকের অন্য একটি সক্রিয় কার্ড আছে।",
    "renewal_pending": "এই কার্ডের একটি নবায়ন শুরু হওয়ার অপেক্ষায় আছে।",
    "already_cancelled": "এই সদস্যপদ আগেই বাতিল।",
    "reason_required": "অনুগ্রহ করে কারণ লিখুন।",
    "invalid_email": "সঠিক ইমেইল দিন।",
    "already_member": "এই ব্যক্তি আগেই সদস্য।",
    "invalid_role": "একটি ভূমিকা বাছুন।",
    "invalid_branch": "এই ফার্মেসির শাখা বাছুন।",
    "last_owner": "ফার্মেসিতে অন্তত একজন সক্রিয় মালিক থাকতে হবে।",
    "owner_has_all": "মালিকের সবসময় পূর্ণ অ্যাক্সেস থাকে।",
    "not_grantable": "এই অনুমতি শুধু মালিকের জন্য।",
    "permission_dependency": "ক্রয় দেখলে ক্রয়মূল্যও দেখা যায়: ক্রয়মূল্য ও লাভ দেখার অনুমতিও দিন।",
    "invalid_permissions": "অনুমতি সঠিক নয়।",
    "no_invitation": "আগে ব্যক্তিকে আমন্ত্রণ জানান (অপেক্ষমাণ আমন্ত্রণ পাওয়া যায়নি)।",
    "not_allowed": "শুধু মালিক এটি করতে পারেন।",
    "owner_password": "মালিক নিজের পাসওয়ার্ড নিজে বদলান।",
    "not_staff_login": "এই ব্যক্তি এই ফার্মেসির ইউজারনেম দিয়ে লগইন করেন না।",
    "password_length": "পাসওয়ার্ড ১০–৭২ অক্ষরের হতে হবে।",
    "password_weak": "পাসওয়ার্ডে বড় ও ছোট হাতের অক্ষর এবং সংখ্যা লাগবে।",
    "invalid_range": "সর্বোচ্চ ৪০০ দিনের সময়কাল বাছুন।",
    "duplicate_branch": "এই কোডে শাখা আগেই আছে।",
    "reload": "আবার লোড করুন"
  },
  "account": {
    "title": "পাসওয়ার্ড পরিবর্তন",
    "new": "নতুন পাসওয়ার্ড",
    "confirm": "নতুন পাসওয়ার্ড আবার দিন",
    "mismatch": "দুটি পাসওয়ার্ড মেলেনি।",
    "saved": "পাসওয়ার্ড পরিবর্তন হয়েছে"
  }
}
